import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import limitedtime from '../../../assets/images/paid-features-img.svg';

const DietPlanCard = ({selectedPlan, onCardClickHandler}) => {
    return(
        <Container className='payment-card-container mt-2'>
            <Row className='diet-plan-cards ps-3 pe-3'>
                <Col xs={4} className="p-1 position-relative">
                    <span className='payment-suggested-lable'>SUGGESTED</span>
                    <div className={`payment-card ${selectedPlan === 'one_month_diet_plan' && 'active'}`} onClick={() => onCardClickHandler('one_month_diet_plan')}>
                        <h1>1 MONTH</h1>
                        <h2>₹799</h2>
                        <h3>Total:₹799</h3>
                    </div>
                </Col>
                <Col xs={4} className="p-1">
                    <div className={`payment-card ${selectedPlan === 'three_month_diet_plan' && 'active'}`} onClick={() => onCardClickHandler('three_month_diet_plan')}>
                        <h1>3 MONTH</h1>
                        <h2>₹699</h2>
                        <h3>Total:₹1999</h3>
                    </div>
                </Col>
                <Col xs={4} className="p-1">
                    <div className={`payment-card ${selectedPlan === 'six_month_diet_plan' && 'active'}`} onClick={() => onCardClickHandler('six_month_diet_plan')}>
                        <h1>6 MONTH</h1>
                        <h2>₹599</h2>
                        <h3>Total:₹3499</h3>
                    </div>
                </Col>
            </Row>
            <div className='text-start'>
                <img src={limitedtime} alt="" className='mt-4 mb-1 limited-time-img' />
            </div>
        </Container>
    );
}

export default DietPlanCard;